<template>
  <div class="content pr-2">
    <div v-html="rulesHtml"/>
  </div>
</template>

<script>
  export default {
    name: '',
    props:['rulesHtml'],
    data () {
      return {}
    },
    computed: {},
    methods: {}
  }
</script>
